import React from "react";

import { AliasCellContent as Content } from "../components";

import base from "./base";

import { Column, ColumnId } from ".";

function alias({ width, onResize }: Column.Options) {
	return base(ColumnId.Alias, (item) => <Content item={item} />, {
		width,

		onResize: onResize as (
			columnWidth?: number | undefined,
			dataKey?: string | undefined,
		) => void,
	});
}

export default alias;
